module.exports = __webpack_public_path__ + "img/C14.930d1fe6.png";